export default __webpack_public_path__ + "static/media/whatsapp_banner_headline_desktop_blue.7bedde26.gif";